import { CRUD, Natural, validNatural, wrapNatural } from './std';


import { AccessLevel } from './runtime';


import { FlakeOutputInternalType, FlakeOutputType } from './ci';










export interface UserAttrs {
  passwordHash: string;
  failedLoginAttempts: Natural;
  availableForCollab: boolean;
  showActivityPublic: boolean;
}

export const validUserAttrs = (input: unknown): UserAttrs => {
  const _x = input as globalThis.Record<string, unknown>;
  if (_x["passwordHash"] === undefined) throw new Error('`_x["passwordHash"]` required but not present');
  if (typeof _x["passwordHash"] != 'string') throw new Error('`_x["passwordHash"]` must be a string');
  if (_x["failedLoginAttempts"] === undefined) throw new Error('`_x["failedLoginAttempts"]` required but not present');
  validNatural(_x["failedLoginAttempts"] as any);
  // handle html checkbox bs
  if(_x["availableForCollab"] === undefined){
    _x["availableForCollab"] = false;
  }else if((_x["availableForCollab"] as unknown) === 'on'){
    _x["availableForCollab"] = true;
  }
  if (_x["availableForCollab"] === undefined) throw new Error('`_x["availableForCollab"]` required but not present');
  if (typeof _x["availableForCollab"] != 'boolean') throw new Error('`_x["availableForCollab"]` must be a boolean');
  // handle html checkbox bs
  if(_x["showActivityPublic"] === undefined){
    _x["showActivityPublic"] = false;
  }else if((_x["showActivityPublic"] as unknown) === 'on'){
    _x["showActivityPublic"] = true;
  }
  if (_x["showActivityPublic"] === undefined) throw new Error('`_x["showActivityPublic"]` required but not present');
  if (typeof _x["showActivityPublic"] != 'boolean') throw new Error('`_x["showActivityPublic"]` must be a boolean');
  const x = input as UserAttrs;
  return x;
}
export const isValidUserAttrs = (input: unknown): boolean => {
  try { validUserAttrs(input); return true; } catch { return false; }
}

export type LanguageExt = "bash" | "beancount" | "bibtex" | "c" | "clojure" | "cmake" | "cpp" | "crystal" | "csharp" | "css" | "cuda" | "cue" | "dart" | "diff" | "dockerfile" | "dot" | "dox" | "elisp" | "elixir" | "elm" | "erlang" | "fennel" | "fish" | "fortran" | "fst" | "gdscript" | "gitignore" | "gleam" | "glsl" | "go" | "graphql" | "haskell" | "hcl" | "heex" | "hjson" | "html" | "java" | "javascript" | "json" | "json5" | "jsonnet" | "julia" | "just" | "kdl" | "kotlin" | "latex" | "ledger" | "llvm" | "lua" | "make" | "markdown" | "nickel" | "nix" | "nu" | "ocaml" | "perl" | "php" | "prisma" | "proto" | "pug" | "python" | "r" | "rego" | "rst" | "ruby" | "rust" | "scala" | "scheme" | "scss" | "sml" | "solidity" | "sparql" | "sql" | "svelte" | "toml" | "tsx" | "turtle" | "typescript" | "typst" | "unknown" | "verilog" | "vim" | "vue" | "wgsl" | "yaml" | "yang" | "zig"

export const validLanguageExt = (x: unknown): LanguageExt => {
  const v = x as [string, unknown] | string;
  if(((v != 'bash')) && ((v != 'beancount')) && ((v != 'bibtex')) && ((v != 'c')) && ((v != 'clojure')) && ((v != 'cmake')) && ((v != 'cpp')) && ((v != 'crystal')) && ((v != 'csharp')) && ((v != 'css')) && ((v != 'cuda')) && ((v != 'cue')) && ((v != 'dart')) && ((v != 'diff')) && ((v != 'dockerfile')) && ((v != 'dot')) && ((v != 'dox')) && ((v != 'elisp')) && ((v != 'elixir')) && ((v != 'elm')) && ((v != 'erlang')) && ((v != 'fennel')) && ((v != 'fish')) && ((v != 'fortran')) && ((v != 'fst')) && ((v != 'gdscript')) && ((v != 'gitignore')) && ((v != 'gleam')) && ((v != 'glsl')) && ((v != 'go')) && ((v != 'graphql')) && ((v != 'haskell')) && ((v != 'hcl')) && ((v != 'heex')) && ((v != 'hjson')) && ((v != 'html')) && ((v != 'java')) && ((v != 'javascript')) && ((v != 'json')) && ((v != 'json5')) && ((v != 'jsonnet')) && ((v != 'julia')) && ((v != 'just')) && ((v != 'kdl')) && ((v != 'kotlin')) && ((v != 'latex')) && ((v != 'ledger')) && ((v != 'llvm')) && ((v != 'lua')) && ((v != 'make')) && ((v != 'markdown')) && ((v != 'nickel')) && ((v != 'nix')) && ((v != 'nu')) && ((v != 'ocaml')) && ((v != 'perl')) && ((v != 'php')) && ((v != 'prisma')) && ((v != 'proto')) && ((v != 'pug')) && ((v != 'python')) && ((v != 'r')) && ((v != 'rego')) && ((v != 'rst')) && ((v != 'ruby')) && ((v != 'rust')) && ((v != 'scala')) && ((v != 'scheme')) && ((v != 'scss')) && ((v != 'sml')) && ((v != 'solidity')) && ((v != 'sparql')) && ((v != 'sql')) && ((v != 'svelte')) && ((v != 'toml')) && ((v != 'tsx')) && ((v != 'turtle')) && ((v != 'typescript')) && ((v != 'typst')) && ((v != 'unknown')) && ((v != 'verilog')) && ((v != 'vim')) && ((v != 'vue')) && ((v != 'wgsl')) && ((v != 'yaml')) && ((v != 'yang')) && ((v != 'zig'))) throw new Error('Invalid LanguageExt `' + JSON.stringify(x) + '`');
  return x as LanguageExt;
}

export type permissionsMatrix = Record<AccessLevel, Record<string, Set<CRUD>>>

export const permissions: permissionsMatrix = {
  'admin': {
    'User': new Set(['create', 'read', 'update', 'delete']),
    'OidcIdentity': new Set(['create', 'read', 'update', 'delete']),
    'Group': new Set(['create', 'read', 'update', 'delete']),
    'GroupMembership': new Set(['create', 'read', 'update', 'delete']),
    'Repo': new Set(['create', 'read', 'update', 'delete']),
    'SshKey': new Set(['create', 'read', 'update', 'delete']),
    'Lane': new Set(['create', 'read', 'update', 'delete']),
    'LaneAssignee': new Set(['create', 'read', 'update', 'delete']),
    'LaneEvent': new Set(['create', 'read', 'update', 'delete']),
    'LaneReview': new Set(['create', 'read', 'update', 'delete']),
    'LaneMerge': new Set(['create', 'read', 'update', 'delete']),
    'Fork': new Set(['create', 'read', 'update', 'delete']),
    'ProtectedBranch': new Set(['create', 'read', 'update', 'delete']),
    'ProtectedTag': new Set(['create', 'read', 'update', 'delete']),
    'UserSocialLink': new Set(['create', 'read', 'update', 'delete']),
    'PinnedRepo': new Set(['create', 'read', 'update', 'delete']),
    'UserFollow': new Set(['create', 'read', 'update', 'delete']),
    'Contribution': new Set(['create', 'read', 'update', 'delete']),
    'Pipeline': new Set(['create', 'read', 'update', 'delete']),
    'CiJob': new Set(['create', 'read', 'update', 'delete']),
    'JobDependency': new Set(['create', 'read', 'update', 'delete']),
    'JobAttempt': new Set(['create', 'read', 'update', 'delete']),
    'Evaluation': new Set(['create', 'read', 'update', 'delete']),
    'FlakeInput': new Set(['create', 'read', 'update', 'delete']),
    'SkillTag': new Set(['create', 'read', 'update', 'delete']),
    'UserSkill': new Set(['create', 'read', 'update', 'delete']),
    'ProjectStory': new Set(['create', 'read', 'update', 'delete']),
    'ProjectStoryTag': new Set(['create', 'read', 'update', 'delete']),
    'ActivityAnnotation': new Set(['create', 'read', 'update', 'delete']),
    'Runner': new Set(['create', 'read', 'update', 'delete']),
    'JobHistory': new Set(['create', 'read', 'update', 'delete']),
    'Secret': new Set(['create', 'read', 'update', 'delete']),
    'WorkspaceTemplate': new Set(['create', 'read', 'update', 'delete']),
    'WorkspacePolicy': new Set(['create', 'read', 'update', 'delete'])
    },
  'write': {
    'User': new Set(['read']),
    'OidcIdentity': new Set(['read']),
    'Group': new Set(['read']),
    'GroupMembership': new Set(['read']),
    'Repo': new Set(['create', 'read', 'update']),
    'SshKey': new Set(['create', 'read', 'update', 'delete']),
    'Lane': new Set(['create', 'read', 'update']),
    'LaneAssignee': new Set(['create', 'read', 'delete']),
    'LaneEvent': new Set(['create', 'read']),
    'LaneReview': new Set(['create', 'read', 'update']),
    'LaneMerge': new Set(['create', 'read']),
    'Fork': new Set(['create', 'read']),
    'ProtectedBranch': new Set(['read']),
    'ProtectedTag': new Set(['read']),
    'UserSocialLink': new Set(['read']),
    'PinnedRepo': new Set(['read']),
    'UserFollow': new Set(['create', 'read', 'delete']),
    'Contribution': new Set(['read']),
    'Pipeline': new Set(['read']),
    'CiJob': new Set(['read']),
    'JobDependency': new Set(['read']),
    'JobAttempt': new Set(['read']),
    'Evaluation': new Set(['read']),
    'FlakeInput': new Set(['read']),
    'SkillTag': new Set(['create', 'read']),
    'UserSkill': new Set(['read']),
    'ProjectStory': new Set(['read']),
    'ProjectStoryTag': new Set(['read']),
    'ActivityAnnotation': new Set(['read']),
    'Runner': new Set(['read']),
    'JobHistory': new Set(['read']),
    'Secret': new Set(['read']),
    'WorkspaceTemplate': new Set(['create', 'read', 'update', 'delete']),
    'WorkspacePolicy': new Set(['read'])
    },
  'read': {
    'User': new Set(['read']),
    'OidcIdentity': new Set(['read']),
    'Group': new Set(['read']),
    'GroupMembership': new Set(['read']),
    'Repo': new Set(['read']),
    'SshKey': new Set(['create', 'read', 'update', 'delete']),
    'Lane': new Set(['read']),
    'LaneAssignee': new Set(['read']),
    'LaneEvent': new Set(['read']),
    'LaneReview': new Set(['read']),
    'LaneMerge': new Set(['read']),
    'Fork': new Set(['read']),
    'ProtectedBranch': new Set(['read']),
    'ProtectedTag': new Set(['read']),
    'UserSocialLink': new Set(['read']),
    'PinnedRepo': new Set(['read']),
    'UserFollow': new Set(['read']),
    'Contribution': new Set(['read']),
    'Pipeline': new Set(['read']),
    'CiJob': new Set(['read']),
    'JobDependency': new Set(['read']),
    'JobAttempt': new Set(['read']),
    'Evaluation': new Set(['read']),
    'FlakeInput': new Set(['read']),
    'SkillTag': new Set(['read']),
    'UserSkill': new Set(['read']),
    'ProjectStory': new Set(['read']),
    'ProjectStoryTag': new Set(['read']),
    'ActivityAnnotation': new Set(['read']),
    'Runner': new Set(['read']),
    'JobHistory': new Set(['read']),
    'Secret': new Set([]),
    'WorkspaceTemplate': new Set(['read']),
    'WorkspacePolicy': new Set(['read'])
    },
  'none': {
    'User': new Set([]),
    'OidcIdentity': new Set([]),
    'Group': new Set([]),
    'GroupMembership': new Set([]),
    'Repo': new Set([]),
    'SshKey': new Set([]),
    'Lane': new Set([]),
    'LaneAssignee': new Set([]),
    'LaneEvent': new Set([]),
    'LaneReview': new Set([]),
    'LaneMerge': new Set([]),
    'Fork': new Set([]),
    'ProtectedBranch': new Set([]),
    'ProtectedTag': new Set([]),
    'UserSocialLink': new Set([]),
    'PinnedRepo': new Set([]),
    'UserFollow': new Set([]),
    'Contribution': new Set([]),
    'Pipeline': new Set([]),
    'CiJob': new Set([]),
    'JobDependency': new Set([]),
    'JobAttempt': new Set([]),
    'Evaluation': new Set([]),
    'FlakeInput': new Set([]),
    'SkillTag': new Set([]),
    'UserSkill': new Set([]),
    'ProjectStory': new Set([]),
    'ProjectStoryTag': new Set([]),
    'ActivityAnnotation': new Set([]),
    'Runner': new Set([]),
    'JobHistory': new Set([]),
    'Secret': new Set([]),
    'WorkspaceTemplate': new Set([]),
    'WorkspacePolicy': new Set([])
    }
};

export const relativeTime = (diff: number): string => {
  return (diff < 60 ? "just now" : (diff < 3600 ? (String(Math.floor(diff / 60))) + "m ago" : (diff < 86400 ? (String(Math.floor(diff / 3600))) + "h ago" : (diff < 604800 ? (String(Math.floor(diff / 86400))) + "d ago" : (diff < 2592000 ? (String(Math.floor(diff / 604800))) + "w ago" : "long ago")))))
}

export const formatDurationMs = (ms: number): string => {
  return (ms < 1000 ? (String(ms)) + "ms" : (ms < 59950 ? (((String(Math.floor((Math.floor((ms + 50) / 100)) / 10))) + ".") + (String((Math.floor((ms + 50) / 100)) - ((Math.floor((Math.floor((ms + 50) / 100)) / 10)) * 10)))) + "s" : (ms < 60000 ? (((String(Math.floor((Math.floor(ms / 100)) / 10))) + ".") + (String((Math.floor(ms / 100)) - ((Math.floor((Math.floor(ms / 100)) / 10)) * 10)))) + "s" : (((String(Math.floor(ms / 60000))) + "m ") + (String((Math.floor(ms / 1000)) - ((Math.floor(ms / 60000)) * 60)))) + "s")))
}

export const knownNixSystemSuffixes: Set<string> =
  new Set(["x86_64-linux", "aarch64-linux", "i686-linux", "x86_64-darwin", "aarch64-darwin", "x86_64-freebsd", "riscv64-linux", "armv7l-linux", "powerpc64le-linux"])


export const formatDurationSec = (s: number): string => {
  return (s < 60 ? (String(s)) + "s" : (s < 3600 ? (String(Math.floor(s / 60))) + "m" : (((String(Math.floor((Math.floor(((s * 10) + 1800) / 3600)) / 10))) + ".") + (String((Math.floor(((s * 10) + 1800) / 3600)) - ((Math.floor((Math.floor(((s * 10) + 1800) / 3600)) / 10)) * 10)))) + "h"))
}

export const formatBytes = (b: number): string => {
  return (b < 1024 ? (String(b)) + " B" : (b < 1048576 ? (((String(Math.floor((Math.floor((b * 10) / 1024)) / 10))) + ".") + (String((Math.floor((b * 10) / 1024)) - ((Math.floor((Math.floor((b * 10) / 1024)) / 10)) * 10)))) + " KB" : (b < 1073741824 ? (((String(Math.floor((Math.floor((b * 10) / 1048576)) / 10))) + ".") + (String((Math.floor((b * 10) / 1048576)) - ((Math.floor((Math.floor((b * 10) / 1048576)) / 10)) * 10)))) + " MB" : (((String(Math.floor((Math.floor((b * 10) / 1073741824)) / 10))) + ".") + (String((Math.floor((b * 10) / 1073741824)) - ((Math.floor((Math.floor((b * 10) / 1073741824)) / 10)) * 10)))) + " GB")))
}

export const toastDismissMs: number =
  5000


export const codeSidebarDefaultWidth: number =
  260


export const codeSidebarMaxFraction: number =
  0.5


export const workspacePanelDefaultWidth: number =
  480


export const workspacePanelMaxFraction: number =
  0.7


export const defaultUserAttrs = (passwordHash: string): UserAttrs => {
  return {
    'passwordHash': passwordHash,
    'failedLoginAttempts': wrapNatural(0),
    'availableForCollab': false,
    'showActivityPublic': true,
  }
}

export const legacyAccessLevelOf = (raw: string): AccessLevel => {
  return (() => {switch (raw) {
      case "owner": {
        return 'admin';
      }
      case "member": {
        return 'write';
      }
      case "viewer": {
        return 'read';
      }
      case "admin": {
        return 'admin';
      }
      case "write": {
        return 'write';
      }
      case "read": {
        return 'read';
      }
      default: {
        return 'none';
      }
    }})()
}

export const flakeOutputTypeInternalAtom = (wire: FlakeOutputType): FlakeOutputInternalType => {
  return (() => {switch (typeof wire === 'string' ? wire : (wire as [string, unknown])[0]) {
      case "check": {
        return 'check';
      }
      case "package": {
        return 'package';
      }
      case "devShell": {
        return 'devShell';
      }
      case "nixosConfiguration": {
        return 'nixosConfiguration';
      }
      case "darwinConfiguration": {
        return 'darwinConfiguration';
      }
      case "hydraJob": {
        return 'hydraJob';
      }
      case "custom": {
        return 'custom';
      }
      case "app": {
        return 'app';
      }
      case "flakeCheck": {
        return 'check';
      }
      case "dispatch": {
        return 'custom';
      }
      case "formatter": {
        return 'formatter';
      }
      case "template": {
        return 'template';
      }
      case "module": {
        return 'nixosModule';
      }
    default: throw new Error('unreachable');
    }})()
}

export const extToLang = (ext: string): LanguageExt => {
  return (() => {switch (ext) {
      case "ex": {
        return 'elixir';
      }
      case "exs": {
        return 'elixir';
      }
      case "heex": {
        return 'heex';
      }
      case "nix": {
        return 'nix';
      }
      case "hs": {
        return 'haskell';
      }
      case "lhs": {
        return 'haskell';
      }
      case "rs": {
        return 'rust';
      }
      case "py": {
        return 'python';
      }
      case "pyw": {
        return 'python';
      }
      case "js": {
        return 'javascript';
      }
      case "mjs": {
        return 'javascript';
      }
      case "cjs": {
        return 'javascript';
      }
      case "jsx": {
        return 'javascript';
      }
      case "ts": {
        return 'typescript';
      }
      case "tsx": {
        return 'tsx';
      }
      case "mts": {
        return 'typescript';
      }
      case "sh": {
        return 'bash';
      }
      case "bash": {
        return 'bash';
      }
      case "zsh": {
        return 'bash';
      }
      case "fish": {
        return 'fish';
      }
      case "json": {
        return 'json';
      }
      case "jsonc": {
        return 'json';
      }
      case "json5": {
        return 'json5';
      }
      case "html": {
        return 'html';
      }
      case "htm": {
        return 'html';
      }
      case "css": {
        return 'css';
      }
      case "scss": {
        return 'scss';
      }
      case "c": {
        return 'c';
      }
      case "h": {
        return 'c';
      }
      case "cpp": {
        return 'cpp';
      }
      case "cc": {
        return 'cpp';
      }
      case "cxx": {
        return 'cpp';
      }
      case "hpp": {
        return 'cpp';
      }
      case "hxx": {
        return 'cpp';
      }
      case "go": {
        return 'go';
      }
      case "java": {
        return 'java';
      }
      case "rb": {
        return 'ruby';
      }
      case "rake": {
        return 'ruby';
      }
      case "sql": {
        return 'sql';
      }
      case "cs": {
        return 'csharp';
      }
      case "scala": {
        return 'scala';
      }
      case "sc": {
        return 'scala';
      }
      case "yml": {
        return 'yaml';
      }
      case "yaml": {
        return 'yaml';
      }
      case "toml": {
        return 'toml';
      }
      case "lua": {
        return 'lua';
      }
      case "zig": {
        return 'zig';
      }
      case "kt": {
        return 'kotlin';
      }
      case "kts": {
        return 'kotlin';
      }
      case "ml": {
        return 'ocaml';
      }
      case "mli": {
        return 'ocaml';
      }
      case "fst": {
        return 'fst';
      }
      case "fsti": {
        return 'fst';
      }
      case "php": {
        return 'php';
      }
      case "dart": {
        return 'dart';
      }
      case "elm": {
        return 'elm';
      }
      case "erl": {
        return 'erlang';
      }
      case "hrl": {
        return 'erlang';
      }
      case "clj": {
        return 'clojure';
      }
      case "cljs": {
        return 'clojure';
      }
      case "cljc": {
        return 'clojure';
      }
      case "edn": {
        return 'clojure';
      }
      case "dockerfile": {
        return 'dockerfile';
      }
      case "makefile": {
        return 'make';
      }
      case "mk": {
        return 'make';
      }
      case "cmake": {
        return 'cmake';
      }
      case "md": {
        return 'markdown';
      }
      case "markdown": {
        return 'markdown';
      }
      case "adoc": {
        return 'markdown';
      }
      case "asciidoc": {
        return 'markdown';
      }
      case "proto": {
        return 'proto';
      }
      case "r": {
        return 'r';
      }
      case "jl": {
        return 'julia';
      }
      case "gleam": {
        return 'gleam';
      }
      case "svelte": {
        return 'svelte';
      }
      case "vue": {
        return 'vue';
      }
      case "graphql": {
        return 'graphql';
      }
      case "gql": {
        return 'graphql';
      }
      case "tf": {
        return 'hcl';
      }
      case "hcl": {
        return 'hcl';
      }
      case "tex": {
        return 'latex';
      }
      case "latex": {
        return 'latex';
      }
      case "sty": {
        return 'latex';
      }
      case "pl": {
        return 'perl';
      }
      case "pm": {
        return 'perl';
      }
      case "vim": {
        return 'vim';
      }
      case "scm": {
        return 'scheme';
      }
      case "ss": {
        return 'scheme';
      }
      case "rkt": {
        return 'scheme';
      }
      case "f": {
        return 'fortran';
      }
      case "f90": {
        return 'fortran';
      }
      case "f95": {
        return 'fortran';
      }
      case "f03": {
        return 'fortran';
      }
      case "sol": {
        return 'solidity';
      }
      case "typ": {
        return 'typst';
      }
      case "gd": {
        return 'gdscript';
      }
      case "glsl": {
        return 'glsl';
      }
      case "vert": {
        return 'glsl';
      }
      case "frag": {
        return 'glsl';
      }
      case "wgsl": {
        return 'wgsl';
      }
      case "ncl": {
        return 'nickel';
      }
      case "just": {
        return 'just';
      }
      case "v": {
        return 'verilog';
      }
      case "sv": {
        return 'verilog';
      }
      case "diff": {
        return 'diff';
      }
      case "patch": {
        return 'diff';
      }
      case "dox": {
        return 'dox';
      }
      case "beancount": {
        return 'beancount';
      }
      case "bib": {
        return 'bibtex';
      }
      case "cr": {
        return 'crystal';
      }
      case "cu": {
        return 'cuda';
      }
      case "cuh": {
        return 'cuda';
      }
      case "cue": {
        return 'cue';
      }
      case "dot": {
        return 'dot';
      }
      case "gv": {
        return 'dot';
      }
      case "el": {
        return 'elisp';
      }
      case "emacs": {
        return 'elisp';
      }
      case "fnl": {
        return 'fennel';
      }
      case "hjson": {
        return 'hjson';
      }
      case "jsonnet": {
        return 'jsonnet';
      }
      case "libsonnet": {
        return 'jsonnet';
      }
      case "kdl": {
        return 'kdl';
      }
      case "ledger": {
        return 'ledger';
      }
      case "ll": {
        return 'llvm';
      }
      case "nu": {
        return 'nu';
      }
      case "prisma": {
        return 'prisma';
      }
      case "pug": {
        return 'pug';
      }
      case "jade": {
        return 'pug';
      }
      case "rego": {
        return 'rego';
      }
      case "rst": {
        return 'rst';
      }
      case "sml": {
        return 'sml';
      }
      case "sparql": {
        return 'sparql';
      }
      case "rq": {
        return 'sparql';
      }
      case "ttl": {
        return 'turtle';
      }
      case "yang": {
        return 'yang';
      }
      default: {
        return 'unknown';
      }
    }})()
}

export const filenameToLang = (name: string): LanguageExt => {
  return (() => {switch (name) {
      case "flake.lock": {
        return 'json';
      }
      case "mix.lock": {
        return 'elixir';
      }
      case ".gitignore": {
        return 'gitignore';
      }
      case ".gitattributes": {
        return 'gitignore';
      }
      case ".gitmodules": {
        return 'bash';
      }
      case ".envrc": {
        return 'bash';
      }
      case ".env": {
        return 'bash';
      }
      case "Makefile": {
        return 'make';
      }
      case "Dockerfile": {
        return 'dockerfile';
      }
      case "Gemfile": {
        return 'ruby';
      }
      case "Rakefile": {
        return 'ruby';
      }
      default: {
        return 'unknown';
      }
    }})()
}


//# sourceMappingURL=index.ts.map
